import React, { useRef } from 'react';
import { Input } from './ui/Field';

interface SearchInputProps {
  value: string;
  onChange: (v: string) => void;
  /** Curto: o campo é estreito e o navegador corta o placeholder sem reticências. */
  placeholder?: string;
  /** Descrição completa do que a busca cobre (leitor de tela e tooltip). */
  ariaLabel?: string;
  label?: string;
  className?: string;
  id?: string;
}

/**
 * Campo de busca com lupa e botão de limpar, para barras de filtro
 * (EmendasFilterBar, EmendasVisaoGeral, etc.). Usa o `Input` padrão: 40px, tokens.
 */
const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  ariaLabel,
  label,
  className = '',
  id,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={id} className="text-xs font-semibold uppercase tracking-wide text-fg-muted">
          {label}
        </label>
      )}
      <Input
        ref={inputRef}
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={label ? undefined : (ariaLabel ?? placeholder)}
        title={ariaLabel}
        startIcon={(
          <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0Z" />
          </svg>
        )}
        endAdornment={value ? (
          <button
            type="button"
            onClick={() => {
              onChange('');
              inputRef.current?.focus();
            }}
            className="flex h-8 w-8 items-center justify-center rounded-full text-fg-subtle hover:text-fg focus:outline-none"
            aria-label="Limpar busca"
          >
            <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        ) : undefined}
      />
    </div>
  );
};

export default SearchInput;
